import { render, staticRenderFns } from "./SuporteBtn.vue?vue&type=template&id=74503f64"
import script from "./SuporteBtn.vue?vue&type=script&lang=js"
export * from "./SuporteBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports